import WidgetApi from '../api/WidgetApi';
import WidgetConstants from '../constants/WidgetConstants';


function fetchItem(metadataId) {
  return {
    types: [
      WidgetConstants.FETCH_ITEM_REQUEST,
      WidgetConstants.FETCH_ITEM_SUCCESS,
      WidgetConstants.FETCH_ITEM_FAILURE
    ],
    apiRequest: (state, apiClient) => WidgetApi.fetchItem(metadataId, apiClient)
  };
}

export default {
  fetchItem
};



// WEBPACK FOOTER //
// ./app/actions/WidgetActions.js